import { Model } from 'pinia-orm';
import { Attr } from 'pinia-orm/decorators'

export default class UserGroup extends Model {
  static entity = 'userGroup'
  static primaryKey = ['user_id', 'group_id']

  @Attr(null) declare user_id: string;
  @Attr(null) declare group_id: string;
}
